<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div class="p-0 text-start pt-2">
                <a class="p-0 back-button text-primary" style="cursor: pointer" :title="$t('key_purchaseDetailTableHeader_button_back')" @click="$router.go(-1)">
                  <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
                </a>
              </div>
              <div class="ms-3">
                  <h5 class="mb-0">{{ title }}</h5>
                  <p class="mb-0 text-sm">{{ description }}</p>
              </div>

              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_returnListTableHeader_button_reload_return')" @change="getPurchase"/>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Tabla con los Datos -->
          <div class="scrollable">
            <GenericTableScrollable
              v-if="!!purchaseData"
              ref="genericTable"
              :items="purchaseData.products"
              :headers="headers"
              :is-loading="isLoading"> <!-- @row-change="paginationRowChange" -->
              <template #row="devolucion">
                <td style="width: 15rem" class="text-sm">
                  <div class="d-flex">
                    <div class="d-lg-flex">
                      <div>
                        <img class="d-inline" :class="!devolucion.image? 'noimageColor': 'image'" :src="!devolucion.image? noimage: devolucion.image" :alt="$t('key_products_image')" />
                      </div>
                      <div class="my-auto mt-4 ms-auto mt-lg-0">
                        <h6 class="my-auto text-sm ms-3 font-weight-bold">
                          <a class="text-primary text-xs" href="#" @click.prevent="goToDetalle(devolucion.product_id)">
                            {{ devolucion.name }}
                          </a>
                        </h6>
                        <span class="text-xs ms-3 font-weight-bold">
                          {{ devolucion.property1 }} - {{ devolucion.property2 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ devolucion.ean }}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ devolucion.sku }}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ devolucion.batch }}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ devolucion.batch_date }}</span>
                </td>
                <td class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ devolucion.warehouse }}</span>
                </td>
                <td class="units text-xs font-weight-bold">
                  <ul>
                    <li><span class="my-2 text-xs text-info">{{ this.$t('key_returnList_informed') }}: {{ $numberFormat.toDecimalFormat(devolucion.units.requested) }}</span></li>
                    <li><span class="my-2 text-xs text-success">{{ this.$t('key_returnList_located') }}: {{ $numberFormat.toDecimalFormat(devolucion.units.completed) }}</span></li>
                  </ul>
                </td>
              </template>
            </GenericTableScrollable>
          </div>
          <div class="col-12 row">
            <purchase-footer :purchase="purchaseData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericTableScrollable from "../../../picko_components/generic_components/GenericTableScrollable.vue";
  import ReloadButton from "./../../../picko_components/generic_components/ReloadButton.vue";
  import noimage from  "@/assets/img/sevica-images/noimage.png";
  import PurchaseFooter from "./PurchaseFooter.vue";

  export default {
    name: "PurchaseDetails",
    components: {
      PurchaseFooter,
      GenericTableScrollable,
      ReloadButton
    },
    data() {
      return {
        noimage,
        isLoading: false
      };
    },
    computed: {
      purchaseData() {
        return this.$store.state.purchase.purchase.data;
      },
      headers() {
        return [
          //{ title: this.$t('key_theader_PurchaseDetail_id'), sort: { sorteable: true, order: '' }, column: 'id' },
          { title: this.$t('key_theader_PurchaseDetail_product'), sort: { sorteable: true, order: '' }, column: 'products.name' },
          { title: this.$t('key_theader_PurchaseDetail_ean'), sort: { sorteable: true, order: '' }, column: 'products.ean' },
          { title: this.$t('key_theader_PurchaseDetail_sku'), sort: { sorteable: true, order: '' }, column: 'products.sku' },
          { title: this.$t('key_theader_PurchaseDetail_batch'), sort: { sorteable: true, order: '' }, column: 'products.batch' },
          { title: this.$t('key_theader_PurchaseDetail_batch_date'), sort: { sorteable: true, order: '' }, column: 'products.batch_date' },
          { title: this.$t('key_theader_PurchaseDetail_warehouse'), sort: { sorteable: true, order: '' }, column: 'products.warehouse' },
          { title: this.$t('key_theader_PurchaseDetail_units'), sort: { sorteable: true, order: '' }, column: 'products.units' }
        ];
      },
      title() {
        return this.purchaseData ? this.purchaseData.number + ' - ' + this.$dateUtils.toNoHourLongDate(this.purchaseData.date) : '';
      },
      description() {
        return this.purchaseData ? this.$t('key_PurchaseDetail_Reference') + ': ' + this.purchaseData.reference : '';
      }
    },
    watch: {
      purchaseData() {
        if(this.purchaseData){
          this.isLoading = false;
        }
      }
    },
    mounted() {
      this.getPurchase();
    },
    methods: {
      goToDetalle(productId){
        this.$router.push({ path: "/MasterData/Products/EditProduct/" + productId});
      },
      getPurchase() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("purchase/getById", this.$route.params.id);
      }
    }
  };
</script>

<style scoped>

  .image {
    height: 2.2rem !important;
    border-radius: 9%;
  }

  .units ul {
    list-style-type: none;
    padding: 0rem;
    margin-bottom: 0rem;
  }

  .scrollable {
    height: 25rem !important;
    overflow: auto;
  }

  .columns {
    max-width: 150px;
  }

</style>